import { RadioGroup } from 'browser/components/atomic-elements/atoms/radio/radio-group'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const RadioGroupField = LabelFieldFactory({ InputComponent: RadioGroup })
export { RadioGroupField }
